// src/IT/pages/ITApprovals.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPendingApprovals } from "../../api/ITapi";
import StatusPill from "../components/StatusPill";

export default function ITApprovals() {
  const [rows, setRows] = useState([]);

  const load = async () => {
    try {
      const data = await listPendingApprovals();
      setRows(data || []);
    } catch (e) {
      alert(e.message);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="it-page">
      <div className="it-card">
        <div className="it-row">
          <div className="it-card-title">Pending Approvals (Manager)</div>
          <button className="it-btn-sm" onClick={load}>Refresh</button>
        </div>

        <table className="it-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Requester</th>
              <th>Type</th>
              <th>Title</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>#{r.id}</td>
                <td>{r.requester_email}</td>
                <td>{r.request_type}</td>
                <td>
                  <Link className="it-link" to={`/it/req/${r.id}`}>{r.title}</Link>
                </td>
                <td><StatusPill status={r.status} /></td>
                <td>{new Date(r.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr>
                <td colSpan="6" className="it-muted">No pending approvals.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
